import React from 'react'
import { useFormContext, useFieldArray } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import FormSubheader from '../create-profile-form/form-subheader'
import TextField from '@material-ui/core/TextField'
import { get } from 'lodash'
import Button from '@material-ui/core/Button'
import TonalButton from 'components/empty-page-state/tonal-button'
import AddIcon from 'components/material-symbol/icons/Add'
import DeleteOutlinedIcon from 'components/material-symbol/icons/Delete'
import {
  getFieldProps,
  requiredLabel,
  useCreateProfileFieldStyles,
} from '../create-profile-form/field-styles'

const MAX_TESTIMONIALS_COUNT = 5
const testimonialsMsg = `Add up to ${MAX_TESTIMONIALS_COUNT} testimonials.`

export const Testimonials = ({ hideSubheader = false }) => {
  const fieldClasses = useCreateProfileFieldStyles()
  const fieldProps = getFieldProps(fieldClasses)
  const { control, errors, register } = useFormContext()
  const { fields, append, remove } = useFieldArray({
    name: 'testimonialsJsonData',
    control,
  })

  return (
    <Box className={fieldClasses.fieldSection}>
      {!hideSubheader ? (
        <FormSubheader title="Testimonials" description={testimonialsMsg} />
      ) : null}
      <Box className={fieldClasses.fieldStack}>
        {fields.map((item, index) => {
          return (
            <Box key={item.id} className={fieldClasses.selectionCard}>
              <Box className={fieldClasses.selectionCardHeader}>
                <Box
                  className={fieldClasses.selectionCardHeaderRow}
                  style={{ justifyContent: 'space-between', width: '100%' }}
                >
                  <Typography
                    component="h4"
                    className={fieldClasses.selectionCardTitle}
                  >
                    {fields.length > 1
                      ? `Testimonial ${index + 1}`
                      : 'Testimonial'}
                  </Typography>
                  <Button
                    className={fieldClasses.selectionCardHeaderAction}
                    type="button"
                    startIcon={<DeleteOutlinedIcon fontSize="small" />}
                    onClick={() => remove(index)}
                  >
                    Delete
                  </Button>
                </Box>
              </Box>
              <Box className={fieldClasses.selectionCardBody}>
                <Box className={fieldClasses.testimonialFieldStack}>
                  <TextField
                    {...fieldProps}
                    multiline
                    minRows={3}
                    name={`testimonialsJsonData[${index}].testimonial`}
                    defaultValue={item.testimonial}
                    label={requiredLabel('Testimonial')}
                    type="text"
                    inputRef={register()}
                    error={
                      !!get(errors, [
                        'testimonialsJsonData',
                        index,
                        'testimonial',
                      ])
                    }
                    helperText={get(errors, [
                      'testimonialsJsonData',
                      index,
                      'testimonial',
                      'message',
                    ])}
                  />
                  <TextField
                    {...fieldProps}
                    name={`testimonialsJsonData[${index}].author`}
                    defaultValue={item.author}
                    label={requiredLabel('Attestant')}
                    type="text"
                    inputRef={register()}
                    error={
                      !!get(errors, ['testimonialsJsonData', index, 'author'])
                    }
                    helperText={get(errors, [
                      'testimonialsJsonData',
                      index,
                      'author',
                      'message',
                    ])}
                  />
                  <input
                    type="hidden"
                    ref={register()}
                    name={`testimonialsJsonData[${index}].rank`}
                    value={index + 1}
                  />
                </Box>
              </Box>
            </Box>
          )
        })}
        <Box>
          <TonalButton
            type="button"
            startIcon={<AddIcon fontSize="small" />}
            onClick={() => {
              append({ testimonial: '', author: '' })
            }}
            disabled={fields.length >= MAX_TESTIMONIALS_COUNT}
          >
            Add Testimonial
          </TonalButton>
        </Box>
      </Box>
    </Box>
  )
}

export default Testimonials
